/* Яндекс карты  */

const $mapWrapper = $('.js-map-wrapper');

if ($mapWrapper.length) {
    const defaultZoom = 15;
    const $mapItems = $('.js-map-item');
    const $currentBubble = $('.js-current-bubble');
    const $currentBubbleContent = $('.js-current-bubble-content');
    const $bubbleCloseBtn = $('.js-bubble-close-btn');
    let itemsMap;
    let clusterer;
    ///let markers = [];

    // вызываем функию генерации данных карты
    generateMapData($mapItems);

    $bubbleCloseBtn.on('click', function (e) {
        $currentBubble.removeClass('_active');

        e.preventDefault();
    });

    /* Генерация карты, добавление объектов и генерация событий */
    function generateMapData(stores) {
        const $map = $mapWrapper.find('.js-map');
        const currentZoom = $map.data('zoom') ? parseFloat($map.data('zoom')) : defaultZoom;
        
        ymaps.ready(function() {
            itemsMap = new ymaps.Map($map[0], {
                center: [59.94, 30.32],
                controls: [],
                zoom: currentZoom
            });

            itemsMap.panes.get('ground').getElement().style.filter = 'grayscale(100%)';
            itemsMap.behaviors.disable('scrollZoom');

            setClusterTemplate();
            addMapData(stores, currentZoom);
            addZoomControls(itemsMap);
        });
    }

    function addMapData(stores, mapZoom) {
        generateMarkers(stores, itemsMap);

        if (stores.length > 1) {
            itemsMap.setBounds(itemsMap.geoObjects.getBounds());
        } else {
            //itemsMap.setCenter([parseFloat(stores.data('lat')), parseFloat(stores.data('lng'))], 15);
            itemsMap.setCenter([parseFloat(stores.data('lat')), parseFloat(stores.data('lng'))], mapZoom);
        }
    }

    /* задаем шаблон для кластеров */
    function setClusterTemplate() {
        // задаем шаблон для кластеров
        const ClusterIconLayout = ymaps.templateLayoutFactory.createClass('<div class="map-cluster"><div class="map-cluster-text">{{ properties.geoObjects.length }}</div></div>');

        // формируем кластеры
        clusterer = new ymaps.Clusterer({
            clusterIconLayout: ClusterIconLayout,
            clusterIconShape: {
                type: 'Circle',
                coordinates: [20, 20],
                radius: 20
            },
            gridSize: 60,
            zIndexHover: 999
        });
    }

    /* генерируем и располагаем на карте маркеры */
    function generateMarkers(stores, map) {
        // обходим все магазины, берем их коорднаты и размешаем метки на карте

        stores.each(function (index, el) {
            let $currEl = $(el);
            let lat = parseFloat($currEl.data('lat'));
            let lng = parseFloat($currEl.data('lng'));
            let id = parseFloat($currEl.data('id'));

            // формируем шаблон метки
            let placemarkData = {
                iconLayout: ymaps.templateLayoutFactory.createClass(
                    `<div class="map-point-icon" data-id="${id}">
                            <div class="map-point-icon__icon-img">
                                <svg><use xlink:href="#sym-map-point"></use></svg>
                            </div>
                        </div>`
                ),
                iconShape: {
                    type: 'Circle',
                    coordinates: [0, -16],
                    radius: 20
                }
            };

            // создаем саму метку на основании ее шаблона
            let myPlacemark = new ymaps.Placemark(
                [lat, lng], {id},
                placemarkData
            );

            // навели на метку
            myPlacemark.events.add('mouseenter', function (e) {
                let currId = e.get('target')['properties'].get('id');

                $(`.map-point-icon[data-id="${currId}"]`).addClass('_hover');

            });

            // убрали наведение с метки
            myPlacemark.events.add('mouseleave', function (e) {
                let currId = e.get('target')['properties'].get('id');

                $(`.map-point-icon[data-id="${currId}"]`).removeClass('_hover');
            });

            // клик на метку
            myPlacemark.events.add('click', function (e) {
                let currId = e.get('target')['properties'].get('id');

                openBubble(currId);
            });

            // добавляем метку на карту
            map.geoObjects.add(myPlacemark);

            //добавляем метку в класте и кластер на карту
            clusterer.add(myPlacemark);
            map.geoObjects.add(clusterer);
        });

    }

    /* устанавливаем центр карты на текущий маркер */
    function setCenterCurrentMarker(id, map) {
        let currStore = $mapItems.filter(`[data-id="${id}"]`);
        let lat = parseFloat(currStore.data('lat'));
        let lng = parseFloat(currStore.data('lng'));
        let mapZoom = map.getZoom();

        map.setCenter([lat, lng], mapZoom > 15 ? mapZoom : 15);
    }

    /* добавляем кнопки зума на карту */
    function addZoomControls(map) {
        let ZoomLayout = ymaps.templateLayoutFactory.createClass('', {
                build: function () {
                    // Вызываем родительский метод build.
                    ZoomLayout.superclass.build.call(this);

                    // Привязываем функции-обработчики к контексту и сохраняем ссылки
                    // на них, чтобы потом отписаться от событий.
                    this.zoomInCallback = ymaps.util.bind(this.zoomIn, this);
                    this.zoomOutCallback = ymaps.util.bind(this.zoomOut, this);

                    // Начинаем слушать клики на кнопках макета.
                    $('.zoom-in').bind('click', this.zoomInCallback);
                    $('.zoom-out').bind('click', this.zoomOutCallback);
                },

                clear: function () {
                    // Снимаем обработчики кликов.
                    $('.zoom-in').unbind('click', this.zoomInCallback);
                    $('.zoom-out').unbind('click', this.zoomOutCallback);

                    // Вызываем родительский метод clear.
                    ZoomLayout.superclass.clear.call(this);
                },

                zoomIn: function () {
                    let map = this.getData().control.getMap();
                    map.setZoom(map.getZoom() + 1, {checkZoomRange: true});
                },

                zoomOut: function () {
                    let map = this.getData().control.getMap();
                    map.setZoom(map.getZoom() - 1, {checkZoomRange: true});
                }}),

            zoomControl = new ymaps.control.ZoomControl({options: {layout: ZoomLayout}});

        map.controls.add(zoomControl);

        $('.map-fullscreen-btn').on('click', function () {
            $mapWrapper.toggleClass('_fullscreen');
            map.container.fitToViewport();
        });
    }

    function openBubble(id) {
        const content = $mapItems.filter(`[data-id="${id}"]`).find('.js-bubble-content').html();

        setCenterCurrentMarker(id, itemsMap);
        $currentBubbleContent.html(content);
        $currentBubble.addClass('_active');
    }
}



// WEBPACK FOOTER //
// ./_src/js/Maps.js